import { gql } from "@apollo/client";

export default gql`
mutation AddMultipleSurveys($userId: ID!, $surveys: [SurveyInput]) {
  addMultipleSurveysToUser(userId: $userId, surveys: $surveys) {
    id
  }
}
`